import { Button, Card, Col, Form, Input, Row, Typography } from "antd"; 
import React, { useState } from "react";
import styles from "./Login.module.css";
import axios from "axios";
import { toast } from "react-toastify";
import { Link, useNavigate } from "react-router-dom";

const Login = () => {
  const [loader, setLoader] = useState(false);
  const navigate = useNavigate();
  const { Title } = Typography;

  const onFinish = async (values) => {
    try {
      setLoader(true);

      // ----------- Login via backend (both admin and normal users) -----------
      const resp = await axios.post("https://rhrmapi.up2dateinc.com/api/auth/login", values);

      if (resp.data.token) {
        // Save token and user info
        localStorage.setItem("access-token", resp.data.token);
        localStorage.setItem("isLogged", true);
        localStorage.setItem("role", resp.data.role); // admin or user
        localStorage.setItem("userId", resp.data._id); // admin_id or user._id

        localStorage.setItem("email", values.email);

        // ✅ FIX HERE
        if (resp.data.role === "admin") {
          localStorage.setItem("username", "Admin");
        } else {
          localStorage.setItem("username", resp.data.userName);
        }

        toast.success("Login Successful");

        // Navigate based on role
        if (resp.data.role === "admin") {
          navigate("/admin/dashboard");
        } else {
          navigate("/user/dashboard");
        }
      } else {
        toast.error("Invalid Username or Password");
      }

    } catch (error) {
      console.error(error);
      toast.error(error.response?.data?.message || "Login failed. Please try again.");
    } finally {
      setLoader(false);
    }
  };

  const onFinishFailed = () => {
    setLoader(false);
    toast.error("Please fill all required fields");
  };

  return (
    <Row className="card-row" justify="center" align="middle">
      <Col xs={22} sm={18} md={12} lg={8}>
        <Card bordered={false} className={styles.card}>
          <Title level={3} className="m-3 text-center">
            Login
          </Title>

          <Form
            name="loginForm"
            labelCol={{ span: 6 }}
            wrapperCol={{ span: 16 }}
            onFinish={onFinish}
            onFinishFailed={onFinishFailed}
            autoComplete="off"
          >
            <Form.Item
              className="mb-5"
              label="Email"
              name="email"
              rules={[{ required: true, message: "Please input your email!" }]}
            >
              <Input />
            </Form.Item>

            <Form.Item
              className="mb-5"
              label="Password"
              name="password"
              rules={[{ required: true, message: "Please input your password!" }]}
            >
              <Input.Password />
            </Form.Item>

            <Form.Item wrapperCol={{ span: 24 }} className={styles.submitBtnContainer}>
              <Button
                type="primary"
                htmlType="submit"
                loading={loader}
                block
              >
                Login
              </Button>
            </Form.Item>
          </Form>

          <div style={{ textAlign: "center", marginTop: "10px" }}>
            Don't have an account?{" "}
            <Link to="/admin/auth/register">Register Here</Link>
          </div>
        </Card>
      </Col>
    </Row>
  );
};

export default Login;